import {Component, OnInit} from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-accept-invitaion',
  templateUrl: './accept-invitaion.component.html',
  styleUrls: ['./accept-invitaion.component.scss']
})
export class AcceptInvitaionComponent implements OnInit {

  constructor(private router: Router) {
  }

  ngOnInit(): void {
  }

  public onAccept() {
    this.router.navigate(['/create-store']);
  }

}
